// extracted by mini-css-extract-plugin
module.exports = {"subscriberLabel":"styles_subscriberLabel__OeWSg"};